import { ref } from 'vue'

const activeAutosaveBlockId = ref<number | null>(null)
const autosaveMessageState = ref<'saved' | 'failed' | null>(null)
const activeRequestId = ref<string | null>(null)

export function useBuildingBlockStatus() {
  const run = async <T>(fn: () => Promise<T>, blockId: number): Promise<T> => {
    const requestId = crypto.randomUUID()
    activeRequestId.value = requestId
    activeAutosaveBlockId.value = blockId
    autosaveMessageState.value = null

    const result = await fn()

    if (activeRequestId.value === requestId) {
      autosaveMessageState.value = result ? 'saved' : 'failed'
    }
    return result
  }

  return { run, activeAutosaveBlockId, autosaveMessageState }
}
